import { IComponentOptions, IController, IFilterService, IOnChangesObject } from 'angular';
import {
  IJobPositionCategory,
  IJobPosition
} from '../../../../../core/services/job-position/job-positions.interfaces';
import { GmcFilterTypes } from '../../gmc-cv-filter-types';
import cloneDeep from 'lodash-es/cloneDeep';
import './position-filter.component.scss';

class PositionFilterController implements IController {
  static $inject = [
    '$filter'
  ];
  public onSubmitResult: ( $event? ) => void;
  public filterType: GmcFilterTypes;
  public positions: IJobPositionCategory[];
  public positionsCopy: IJobPositionCategory[];
  public selectedCategories: IJobPositionCategory[] = [];
  public filteredCategories: IJobPositionCategory[] = [];
  public selectedPositions: IJobPosition[];
  public searchTerm = '';
  public searchActive = false;

  constructor( private $filter: IFilterService ) {
  }

  public $onChanges( changes: IOnChangesObject ) {
    if ( changes.positionsCopy && changes.positionsCopy.currentValue ) {
      this.positionsCopy = changes.positionsCopy.currentValue as IJobPositionCategory[];
      this.positions = cloneDeep(this.positionsCopy);
      console.log(this.positions);
    }
  }

  public toggleCategory( category: IJobPositionCategory ) {
    this.searchTerm = '';
    if ( this.searchActive ) {
      this.selectedCategories = [];
      this.searchActive = false;
      this.positions = cloneDeep(this.positionsCopy);
    }
    if ( this.filterType === GmcFilterTypes.ONLY_POSITION ) {
      // return this.selectedCategories = [ category ];
    }
    const index = this.selectedCategories.findIndex(( _category ) => _category._id === category._id);
    if ( index > -1 ) {
      this.selectedCategories.splice(index, 1);
    } else {
      this.selectedCategories.push(category);
    }
  }

  public selectSinglePosition( position: IJobPosition ) {
    this.selectedPositions = [ position ];
  }

  public isCategorySelected( category: IJobPositionCategory ): boolean {
    return this.selectedCategories.findIndex(( _category ) => _category._id === category._id) > -1;
  }

  public selectMultiplePosition( position: IJobPosition ) {
    const index = this.selectedPositions.indexOf(position);
    if ( index > -1 ) {
      this.selectedPositions.splice(index, 1);
    } else {
      this.selectedPositions.push(position);
    }
  }

  public filterPositions() {
    if ( this.searchTerm.length >= 3 ) {
      this.selectedCategories = [];
      this.searchActive = true;
      const positions = cloneDeep(this.positionsCopy);
      this.filteredCategories = this.$filter('filter')(positions, ( category ) => {
        category.categories = this.$filter('filter')(category.categories, this.searchTerm);
        return !!category.categories.length;
      });
    }
  }

  public resetSearch() {
    this.searchTerm = '';
    this.selectedCategories = [];
    this.filteredCategories = [];
    this.selectedPositions = [];
  }

  public submitResult() {
    this.onSubmitResult();
  }
}

export const PositionFilterComponent: IComponentOptions = {
  controller: PositionFilterController,
  template: require('./position-filter.component.html'),
  bindings: {
    filterType: '<',
    positionsCopy: '<positions',
    selectedPositions: '=',
    onSubmitResult: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-cv-filter/components/position-filter/position-filter.component.ts